export const LBL_SAVE="SAVE";
export const LBL_CANCEL="CANCEL";
export const LBL_RESET="RESET";
export const LBL_ADD="ADD";
export const LBL_ADD_STOCK="ADD STOCK";
export const LBL_DELETE="DELETE";
export const LBL_EDIT="EDIT";
export const LBL_UPDATE="UPDATE";
export const LBL_FETCH="FETCH";
export const LBL_ERROR="ERROR";
export const LBL_SEARCH="Search";
export const LBL_SEARCHING="Searching...";
export const LBL_LOADING = "Loading...";
export const LBL_SUBMIT = "Submit";
export const LBL_SAVING = "Saving...";




export const LBL_TYPE_GOODS = "Goods";
export const LBL_TYPE_SERVICE = "Service";
export const LBL_ITEM_TYPE = "Item Type";
export const LBL_ITEM_TYPE_INVENTORY = "Inventory";
export const LBL_ITEM_TYPE_NONINVENTORY = "Non-Inventory";

export const LBL_ITEM_NAME = "Item Name";
export const LBL_HSN = "HSN";
export const LBL_SKU = "SKU";
export const LBL_UPC = "UPC";
export const LBL_IAN = "IAN";
export const LBL_QUANTITY = "Quantity";
export const LBL_COST_PRICE = "Cost Price";
export const LBL_SELLING_PRICE = "Selling Price";
export const LBL_STOCK_QUANTITY = "Stock Quantity";
export const LBL_REORDER_POINT = "Reorder Point";
export const LBL_UOM = "Unit of Measure (UOM)";
export const LBL_DESCRIPTION = "Description";
export const LBL_BRAND = "Brand";
export const LBL_MANUFACTURER = "Manufacturer";
export const LBL_CATEGORY = "Category";
export const LBL_WAREHOUSE = "Warehouse";
export const LBL_BATCH_NUMBER = "Batch Number";
export const LBL_LOT_NUMBER = "Lot Number";
export const LBL_EXPIRY_DATE = "Expiry Date";
export const LBL_DISCOUNT_RATE = "Discount Rate";
export const LBL_TAXABLE = "Taxable";
export const LBL_NON_TAXABLE = "Non-Taxable";
export const LBL_TAX_PREFERENCE = "Tax Preference";
export const LBL_CREATE_ATTRIBUTES = "Create Attributes and Options";
export const LBL_ATTRIBUTE_NAME = "Attribute Name";
export const LBL_ATTRIBUTE_OPTION = "Attribute Option";
export const LBL_ADD_ATTRIBUTE = "Add Attribute";
export const LBL_REMOVE = "Remove";
export const LBL_ADD_ITEM = "Add Item";
export const LBL_HELP_GUIDE = "User Guide";
export const LBL_TOOLTIP_HELP = "Download User Guide";
export const LBL_OTHER_DETAILS = "Other Details";
export const LBL_BASIC_DETAILS = "Basic Details";
export const LBL_INVENTORY_DETAILS = "Inventory Details";
export const LBL_ATTRIBUTES_SECTION = "Attributes";
export const LBL_ADDITIONAL_FIELDS = "Additional Fields";
export const LBL_UOM_FULL = "Unit of Measure (UOM) *";
export const LBL_GST = "GST";

export const LBL_UOM_PCS = "PIECES";
export const LBL_UOM_KG = "KG";
export const LBL_UOM_GM = "GM";
export const LBL_UOM_CM = "CM";
export const LBL_UOM_INCH = "INCH";
export const LBL_UOM_M = "METR";
export const LBL_UOM_MM = "MM";
export const LBL_UOM_FT = "FT";
export const LBL_UOM_LOT = "LOT";
export const LBL_UOM_PK = "PACKET";
export const LBL_UOM_LTR = "LITR";
export const LBL_UOM_BOTTLE = "BOTTLE";
export const LBL_UOM_BAG = "BAG";
export const LBL_NEW = "Add New";
export const LBL_EMAIL = "Email";
export const LBL_CONTACT_PHONE = "Contact Phone";
export const LBL_STREET = "Street";
export const LBL_CITY = "City";
export const LBL_STATE = "State";
export const LBL_ZIP = "Zip";
export const LBL_COUNTRY = "Country";


export const LBL_CUSTOMER_NAME = "Customer Name";
export const LBL_VENDOR_NAME = "Vendor Name"

export const LBL_BACK = "Back";
export const LBL_TYPE = "Type:";
export const LBL_INVENTORY_AND_PRICING = "Item Details and Pricing & Inventory";
export const LBL_NO_ADDITIONAL_ATTRIBUTES_AVAILABLE = "No additional attributes available.";
export const LABELS = {
  ITEM_ID: "Item ID",
  ITEM_NAME: "Name",
  BRAND: "Brand",
  CATEGORY: "Category",
  MANUFACTURER: "Manufacturer",
  HSN: "HSN",
  TAXABLE: "Taxable",
  TYPE: "Type",
  UNIT: "Unit",
  ITEM_TYPE: "Item Type",
  DESCRIPTION: "Description",
  ITEM_ATTRIBUTES: "Item Attributes",
};



export const PLACEHOLDER_SELECT_CATEGORY = "Select Category *";
export const PLACEHOLDER_SELECT_BRAND = "Select Brand";
export const PLACEHOLDER_SELECT_OPTIONS = "Select Options";
export const PLACEHOLDER_SELECT_MANUFACTURER = "Select Manufacturer";
export const PLACEHOLDER_SELECT_UOM = "Select UOM";
export const PLACEHOLDER_ENTER_DESCRIPTION = "Enter Description";
export const PLACEHOLDER_SELECT_ATTRIBUTE_NAME = "Select Attribute Name *";
export const PLACEHOLDER_ITEM_NAME = "Enter Item Name";
export const PLACEHOLDER_COST_PRICE = "0.00";
export const PLACEHOLDER_SELLING_PRICE = "0.00";
export const PLACEHOLDER_STOCK_QUANTITY = "0";
export const PLACEHOLDER_REORDER_POINT = "0";
export const PLACEHOLDER_BATCH_NUMBER = "Enter Batch Number";
export const PLACEHOLDER_LOT_NUMBER = "Enter Lot Number";
export const PLACEHOLDER_EXPIRY_DATE = "yyyy-mm-dd";
export const PLACEHOLDER_DISCOUNT_RATE = "0.00";
export const PLACEHOLDER_ATTRIBUTE_NAME = "Enter Attribute Name";
export const PLACEHOLDER_ATTRIBUTE_OPTION = "Enter Attribute Option";
export const PLACEHOLDER_SELECT_CATEGORY_OPTION = "Select Category";
export const PLACEHOLDER_CUSTOMER_NAME = "Enter Customer Name";
export const PLACEHOLDER_VENDOR_NAME = "Enter Vendor Name";
export const PLACEHOLDER_FIRST_NAME = "First Name";
export const PLACEHOLDER_LAST_NAME = "Last Name";
export const PLACEHOLDER_EMAIL = "Email";
export const PLACEHOLDER_GST = "Enter GST Percentage";
export const PLACEHOLDER_PHONE_NUMBER = "Phone Number";
export const PLACEHOLDER_STREET_ADDRESS = "Street Address";
export const PLACEHOLDER_PIN_CODE = "Pin Code";


export const LBL_MULTIPLE_ITEMS = "Multiple Items:";
export const PLACEHOLDER_SELECT_SIZE = "Select Size";
export const LBL_Search = "🔍 Search by item name, category, brand, manufacturer...";

export const HEADER_NAMES = {
  ITEM_NAME: "Item Name",
  DESCRIPTION: "Desc.",
  HSN: "HSN",
  QUANTITY: "Qty",
  COST_PRICE: "Cost Price",
  SELLING_PRICE: "Selling Price",
  CATEGORY: "Category",
  BRAND: "Brand",
  MANUFACTURER: "Manufacturer",
  ACTIONS: "Actions",
};
export const SUCCESS="success";